import glamorous from 'glamorous';
import themes from "../../themes"


const BookListStyled = glamorous.ul({
        paddingLeft: '80px',
        margin: "20px",
        fontSize: "30px",
        cursor: 'pointer',
        display: "flex",
        flexDirection: "flex-start",
        borderRadius: "10px",
        display: "flex",
},
props => {
  switch (props.theme) {
    case "dark": {
      return { backgroundColor: themes[0].base } 
    }
    case "light": {
      return { backgroundColor: themes[1].base }
    }
  }
}
);


export default BookListStyled


// WEBPACK FOOTER //
// ./src/containers/booklist/BookListStyled.js